import { Component, OnInit, ViewEncapsulation, OnDestroy, inject, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { IInfo, IHeader, IQuestionnaires, IReceipt } from 'app/interfaces';
import { UserSessionsService } from 'app/shared/services/user-sessions/user-sessions.service';
import { DocumentsService } from 'app/shared/services/documents/documents.service';
import { HomeService } from '../../services/home.service';
import { NgStyle } from '@angular/common';
import { ShowMoreComponent } from '../show-more/show-more.component';
import { SafeHtmlPipe } from 'app/shared/pipes/safe-html.pipe';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-vaccination-verifications',
  templateUrl: './vaccination-verifications.component.html',
  styleUrls: ['./vaccination-verifications.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [NgStyle, ShowMoreComponent],
})
export class VaccinationVerificationsComponent implements OnInit, OnDestroy {
  info: IInfo[] = [];
  imgHeight: number;
  imgWidth: number;
  questionnaires: IQuestionnaires[] = [];
  selectedInfo: IInfo | null = null;
  status: IHeader | null = null;
  isFlu: boolean = false;
  displayLearnMore: boolean = false;
  statusColor: string = '';
  subs: Subscription[] = [];
  safeHtmlMessage: SafeHtml | string = '';

  colors = {
    ORANGE: '#F68F1D',
    RED: '#D15746',
    GREEN: '#88B03F',
    PURPLE: '#AF4591',
    LIGHTCORAL: 'lightcoral',
  };
  outageMessage: string = '';
  private router: Router = inject(Router);
  private sanitizer = inject(SafeHtmlPipe);
  public documentsService: DocumentsService = inject(DocumentsService);
  public userSession: UserSessionsService = inject(UserSessionsService);
  private homeService: HomeService = inject(HomeService);
  constructor() {
    this.imgHeight = 0;
    this.imgWidth = 850;
  }

  ngOnInit() {
    localStorage.setItem('allowAssessment', 'false');
    this.statusColor = this.colors.ORANGE;
    this.userSession.outageMessage.subscribe({
      next: (message) => {
        if (message) {
          this.outageMessage = message;
        }
      },
    });

    this.subs.push(
      this.homeService.activeCampaign.subscribe({
        next: (campaign) => {
          if (campaign === 'flu') {
            this.isFlu = true;
            this.subs.push(
              this.homeService.fluInfo.subscribe({
                next: (data) => {
                  this.setInfo(data);
                },
              }),
            );
            this.subs.push(
              this.homeService.fluHeader.subscribe({
                next: (data) => {
                  this.setHeader(data);
                },
              }),
            );
            this.subs.push(
              this.homeService.fluQuestionnaires.subscribe({
                next: (data) => {
                  this.setQuestionnaire(data);
                },
              }),
            );
          } else {
            this.isFlu = false;
            this.subs.push(
              this.homeService.covidInfo.subscribe({
                next: (data) => {
                  this.setInfo(data);
                },
              }),
            );
            this.subs.push(
              this.homeService.covidHeader.subscribe({
                next: (data) => {
                  this.setHeader(data);
                },
              }),
            );
            this.subs.push(
              this.homeService.covidQuestionnaires.subscribe({
                next: (data) => {
                  this.setQuestionnaire(data);
                },
              }),
            );
          }
        },
      }),
    );
  }

  setInfo(campaignData: IInfo[]) {
    if (campaignData) {
      this.info = campaignData;
    }
  }

  setHeader(campaignData: IHeader | null) {
    if (campaignData) {
      const regex = /<[^>]*>/g;
      this.safeHtmlMessage = regex.test(campaignData.message) ? this.sanitizer.transform(campaignData.message) : campaignData.message;
      this.status = campaignData;

      switch (campaignData.statusId) {
        case 1:
          this.statusColor = this.colors.ORANGE;
          break;
        case 2:
          this.statusColor = this.colors.GREEN;
          break;
        case 3:
          this.statusColor = this.colors.RED;
          break;
        case 4:
          this.statusColor = this.colors.PURPLE;
          break;
        case 5:
          this.statusColor = this.colors.LIGHTCORAL;
          break;
        case 6:
          this.statusColor = this.colors.GREEN;
          break;
      }
    }
  }

  setQuestionnaire(campaignData: IQuestionnaires[]) {
    if (campaignData) {
      this.questionnaires = campaignData;
    }
  }

  showLearnMore(info: IInfo) {
    this.selectedInfo = info;
    this.createImg();
  }

  closeLearnMore() {
    this.displayLearnMore = false;
  }

  createImg() {
    const img = new Image();
    img.addEventListener('load', (e) => {
      /* compute img height before loading  */
      this.imgHeight = (this.imgWidth / img.width) * img.height;
      this.displayLearnMore = true;
    });
    if (this.selectedInfo?.imageUrl) {
      img.src = this.selectedInfo?.imageUrl;
    }
  }

  showQuestionary(question: IQuestionnaires) {
    this.homeService.startAssessment(question);
  }

  addInfo(question: IQuestionnaires) {
    this.router.navigate(['/home/info/' + question.questionnaireInstanceId]);
  }

  showDownload(question: IQuestionnaires) {
    this.documentsService.downloadDocument(question.documentId, question.cloudDocumentUri, question.questionnaireInstanceId);
  }

  showReceipt(receipt: IReceipt, id?: number) {
    this.documentsService.showReceipt(
      receipt.receiptTypeId,
      receipt.employeeFluSeasonRecordId === undefined ? null : receipt.employeeFluSeasonRecordId,
      receipt.campaignSeasonId,
      this.isFlu,
      id,
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
